import React, { useState, useEffect } from "react";
import {
  useDisclosure,
  Box,
  Button,
  Text,
  Flex,
  Select,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  CheckboxGroup,
  Checkbox,
  Stack,
  Heading,
  Badge,
  IconButton,
  Icon,
  useToast,
  HStack,
  Divider,
} from "@chakra-ui/react";
import {
  FaSync,
  FaPrint,
  FaPlus,
  FaEdit,
  FaListAlt,
  FaUserTie,
  FaCalendarAlt,
  FaClock,
  FaEnvelope,
  FaPaperclip,
  FaUsers,
  FaImage,
} from "react-icons/fa";
import { InfoOutlineIcon, EditIcon, DeleteIcon } from "@chakra-ui/icons";
import axios from "axios";
import { CalendarIcon } from "@chakra-ui/icons";
import Calender from "./Calender";
import { Link } from "react-router-dom";
import EventCategoryCreate from "./Event_Category_Create";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Event = () => {
  const schoolId = sessionStorage.getItem("school_id");

  const [currentPage, setCurrentPage] = useState(1);
  const [teachers, setTeachers] = useState([]); // Store fetched teachers

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isDetailModalOpen,
    onOpen: onOpenDetailModal,
    onClose: onCloseDetailModal,
  } = useDisclosure();
  const [formData, setFormData] = useState({
    id: null,
    title: "",
    event_category_id: "",
    start_date: "",
    end_date: "",
    start_time: "",
    end_time: "",
    attachment: null,
    message: "",
    user_types: [],
  });

  // Fetch teachers from API
  const fetchTeachers = async () => {
    try {
      const jwt = sessionStorage.getItem("jwt");
      const school_id = sessionStorage.getItem("school_id"); // If JWT is needed

      const response = await axios.get(
        `${BASE_URL}/admin/staff/staff_list.php?school_id=${school_id}`,
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        }
      );
      console.log("staff_list", response);
      // setTeachers(response.data.data); // Set teachers data
      setTeachers(Array.isArray(response.data.data) ? response.data.data : []);

      // if (response.data.status === "success") {
      //   setTeachers(response.data.data); // Set teachers data
      // } else {
      //   setError(response.data.message || "Error fetching teachers");
      // }
    } catch (error) {
      console.error("Error fetching teachers:", error);
      setError("Network Error: " + (error.message || error));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTeachers(); // Call the function on component mount
  }, []);

  // Call fetchTeachers on component mount
  useEffect(() => {
    fetchTeachers();
  }, []); // Empty dependency array to run once when component mounts

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString(undefined, options);
  };
  const capitalizeWords = (str) => {
    return str
      .split(" ") // Split the string into words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
      .join(" "); // Join the words back into a string
  };

  const [events, setEvents] = useState([]);
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);

  // Fetch events from the API
  const fetchEvents = async (schoolId) => {
    try {
      // Make the GET request to the PHP API with the schoolId as a query parameter
      const response = await axios.get(
        `${BASE_URL}/admin/events/event/list_all_event.php?school_id=${schoolId}`
      );

      // Check if the response is successful
      if (response.data.success) {
        console.log("event list ress:", response);

        // Set the events if successful
        setEvents(response.data.data.events);
      } else {
        // Set the error message if not successful
        setError("Failed to fetch events.");
      }
    } catch (err) {
      // Handle any errors from the API request
      setError("Error fetching events: " + err.message);
    } finally {
      // Set loading to false when the request is finished
      setLoading(false);
    }
  };

  // Call fetchEvents when the component mounts
  useEffect(() => {
    fetchEvents();
  }, []);

  useEffect(() => {
    if (!isEditing) {
      resetForm(); // Reset form data when switching to "Add Event" mode
    }
  }, [isEditing]);

  const resetForm = () => {
    setFormData({
      id: null,
      title: "",
      event_category_id: "",
      start_date: "",
      end_date: "",
      start_time: "",
      end_time: "",
      attachment: null,
      message: "",
      user_types: [],
    });
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, attachment: e.target.files[0] });
  };

  const handleCheckboxChange = (value) => {
    setFormData({ ...formData, user_types: value });
  };
  console.log(formData); // Check if title exists

  const handleSubmit = async () => {
    const {
      id,
      title,
      event_category_id,
      start_date,
      end_date,
      start_time,
      end_time,
      attachment,
      message,
      user_types,
    } = formData;

    let base64Attachment = null;
    if (attachment) {
      const reader = new FileReader();
      reader.readAsDataURL(attachment);
      reader.onloadend = async () => {
        base64Attachment = reader.result;
        await submitEvent({
          id,
          title,
          event_category_id,
          start_date,
          end_date,
          start_time,
          end_time,
          message,
          user_types,
          attachment: base64Attachment,
        });
      };
      reader.onerror = (error) => {
        console.error("Error reading file:", error);
      };
    } else {
      await submitEvent({
        id,
        title,
        event_category_id,
        start_date,
        end_date,
        start_time,
        end_time,
        message,
        user_types,
      });
    }
  };
  useEffect(() => {
    console.log("Modal opened:", isDetailModalOpen, "Form Data:", formData);
  }, [isDetailModalOpen, formData]);

  useEffect(() => {
    // Fetch event categories when the modal is opened
    const fetchCategories = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/admin/events/event_master/list.php?school_id=${schoolId}`
        );
        const result = await response.json();
        if (result.success) {
          setCategories(result.data); // Assuming 'data' contains the event categories
        } else {
          setError(result.message);
        }
      } catch (err) {
        setError("Failed to fetch categories.");
      }
    };

    if (schoolId) {
      fetchCategories();
    }
  }, [schoolId]);

  const submitEvent = async (data) => {
    const url = isEditing
      ? `${BASE_URL}/admin/events/event/edit_event.php`
      : `${BASE_URL}/admin/events/event/create_event.php`;

    // Prepare request data
    const requestData = {
      event_id: data.id,
      title: data.title,
      event_master_id: data.event_category_id, // updated field name for consistency
      start_date: data.start_date,
      end_date: data.end_date,
      start_time: data.start_time,
      end_time: data.end_time,
      message: data.message,
      school_id: sessionStorage.getItem("school_id"),
      user_types: data.user_types,
      teacher_id: data.id, // Make sure teacher_id is passed correctly
      pass: sessionStorage.getItem("user_id"), // Assuming user_id is stored here
    };

    console.log("submit", requestData);

    // If there’s an attachment, add it to the requestData
    if (data.attachment) {
      requestData.attachment = data.attachment; // Make sure the attachment is base64-encoded
    }

    try {
      const method = isEditing ? "PUT" : "POST";
      const response = await fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (response.ok) {
        const responseData = await response.json();
        console.log("res", responseData);

        if (responseData.success) {
          toast({
            title: "Success",
            description: "Event submitted successfully!",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          // Reset the form data after a successful submission
          setFormData({
            id: null,
            title: "",
            event_category_id: "",
            start_date: "",
            end_date: "",
            start_time: "",
            end_time: "",
            attachment: null,
            message: "",
            user_types: [],
            teacher_id: "", // Reset teacher_id
          });

          onClose(); // Close the modal or form
          fetchEvents(); // Refresh the event list
        } else {
          toast({
            title: "Error",
            description: responseData.message || "Failed to submit event!",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
          console.error("Error creating/updating event:", responseData.message);
        }
      } else {
        console.error("Error creating/updating event:", response.statusText);
        toast({
          title: "Error",
          description: "An error occurred while processing your request.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error:", error);
      toast({
        title: "Error",
        description: "An error occurred while sending the request.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const userTypeMapping = {
    3: "Student",
    2: "Teacher",
    4: "Guardian",
    // Add more mappings as needed
  };

  return (
    <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
      <div className="teacher-list-container">
        <div className="header">
          <h1 style={{ fontSize: "20px", margin: 0 }}>Event</h1>

          <div className="action-buttons">
            <EventCategoryCreate />

            <Button
              onClick={() => {
                onOpen();
                setIsEditing(false);
              }}
              leftIcon={<FaPlus />}
              colorScheme="teal"
              size={{ base: "xs", md: "md" }}
            >
              <Text display={{ base: "none", md: "inline" }}>Event</Text>{" "}
            </Button>
          </div>
        </div>
        <div className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Announcement</span> / <span>Event</span>
        </div>
        <Box mt={4}>
          <Calender />
        </Box>
      </div>

      {/* Modal for adding/editing events */}
      <Modal
        size="lg"
        motionPreset="slideInBottom"
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          borderRadius="lg"
          boxShadow="xl"
          bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
          color="gray.700"
          p={6}
          maxW="700px"
          maxH="550px"
          overflowY="auto"
        >
          <ModalHeader
            fontSize="xl"
            fontWeight="bold"
            textAlign="center"
            color="teal.600"
          >
            <Icon as={isEditing ? FaEdit : FaPlus} boxSize={5} mr={2} />
            {isEditing ? "Edit Event" : "Add Event"}
          </ModalHeader>

          <ModalCloseButton />
          <ModalBody
            overflowY="auto"
            px={4}
            css={{
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(173, 216, 230, 0.6)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "rgba(173, 216, 230, 0.9)",
              },
            }}
          >
            {" "}
            <FormControl isRequired>
              <FormLabel>
                {" "}
                <Icon as={FaEdit} mr={1} color="teal.500" />
                Event Title
              </FormLabel>
              <Input
                bg="white"
                _hover={{ borderColor: "teal.300" }}
                name="title"
                value={formData.title}
                onChange={handleFormChange}
              />
            </FormControl>
            <HStack spacing={4} mt={4} wrap="nowrap">
              {/* Event Category Dropdown */}
              <FormControl mt={4} isRequired>
                <FormLabel>
                  {" "}
                  <Icon as={FaListAlt} mr={1} color="teal.500" />
                  Event Category
                </FormLabel>
                <Select
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  name="event_category_id"
                  value={formData.event_category_id}
                  onChange={handleFormChange}
                >
                  <option value="">Select category</option>
                  {categories.map((category) => (
                    <option key={category.id} value={category.id}>
                      {category.event_master}{" "}
                      {/* Assuming 'event_master' is the category name */}
                    </option>
                  ))}
                </Select>
              </FormControl>

              {/* Allocated Teachers Dropdown */}
              <FormControl mt={4} isRequired>
                <FormLabel>
                  {" "}
                  <Icon as={FaUserTie} mr={1} color="teal.500" />
                  Allocated Teachers
                </FormLabel>
                {loading ? (
                  <Text>Loading teachers...</Text>
                ) : error ? (
                  <Text color="red.500">{error}</Text>
                ) : (
                  <Select
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    name="allocated_teacher_id"
                    placeholder="Select Teacher"
                    value={formData.id} // Bind the selected teacher's ID
                    onChange={(e) =>
                      setFormData({ ...formData, id: e.target.value })
                    } // Update state on change
                  >
                    {teachers.map((teacher) => (
                      <option key={teacher.id} value={teacher.id}>
                        {teacher.name}
                      </option>
                    ))}
                  </Select>
                )}
              </FormControl>
            </HStack>
            {/* Date and Time Fields */}
            <HStack spacing={4} mt={4} wrap="nowrap">
              <FormControl isRequired flex="1">
                <FormLabel>
                  {" "}
                  <Icon as={FaCalendarAlt} mr={1} color="teal.500" />
                  Start Date
                </FormLabel>
                <Input
                  type="date"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  name="start_date"
                  value={formData.start_date}
                  onChange={handleFormChange}
                />
              </FormControl>

              <FormControl isRequired flex="1">
                <FormLabel>
                  {" "}
                  <Icon as={FaCalendarAlt} mr={1} color="teal.500" />
                  End Date
                </FormLabel>
                <Input
                  type="date"
                  name="end_date"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={formData.end_date}
                  onChange={handleFormChange}
                />
              </FormControl>
            </HStack>
            <HStack spacing={4} mt={4} wrap="nowrap">
              <FormControl isRequired flex="1">
                <FormLabel>
                  {" "}
                  <Icon as={FaClock} mr={1} color="teal.500" />
                  Start Time
                </FormLabel>
                <Input
                  type="time"
                  name="start_time"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={formData.start_time}
                  onChange={handleFormChange}
                />
              </FormControl>

              <FormControl isRequired flex="1">
                <FormLabel>
                  {" "}
                  <Icon as={FaClock} mr={1} color="teal.500" />
                  End Time
                </FormLabel>
                <Input
                  type="time"
                  name="end_time"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={formData.end_time}
                  onChange={handleFormChange}
                />
              </FormControl>
            </HStack>
            {/* Message Field */}
            <FormControl mt={4}>
              <FormLabel>
                {" "}
                <Icon as={FaEnvelope} mr={1} color="teal.500" />
                Message
              </FormLabel>
              <Textarea
                name="message"
                bg="white"
                _hover={{ borderColor: "teal.300" }}
                value={formData.message}
                onChange={handleFormChange}
                resize="vertical"
                rows={6}
              />
            </FormControl>
            {/* Attachment Field */}
            <FormControl mt={4}>
              <FormLabel>
                {" "}
                <Icon as={FaPaperclip} mr={1} color="teal.500" />
                Attachment
              </FormLabel>
              <Input
                type="file"
                bg="white"
                _hover={{ borderColor: "teal.300" }}
                onChange={handleFileChange}
              />
              {formData.attachment && (
                <Text mt={2}>Selected File: {formData.attachment.name}</Text>
              )}
            </FormControl>
            {/* Event for Checkbox */}
            <FormControl mt={4}>
              <FormLabel>
                {" "}
                <Icon as={FaUsers} mr={1} color="teal.500" />
                Event for
              </FormLabel>
              <CheckboxGroup
                colorScheme="teal"
                // bg="white"
                // _hover={{ borderColor: "teal.300" }}
                value={formData.user_types}
                onChange={handleCheckboxChange}
              >
                <Stack spacing={[1, 1]} direction={["column", "row"]}>
                  <Checkbox value="3">Student</Checkbox>
                  <Checkbox value="2">Teacher</Checkbox>
                  <Checkbox value="4">Guardian</Checkbox>
                </Stack>
              </CheckboxGroup>
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button
              bgGradient="linear(to-r, teal.400, teal.600)"
              color="white"
              _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
              mr={3}
              onClick={handleSubmit}
            >
              {isEditing ? "Update" : "Create"}
            </Button>
            {/* <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button> */}
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Modal for event details */}
      {/* Modal for event details */}
      <Modal isOpen={isDetailModalOpen} onClose={onCloseDetailModal}>
        <ModalOverlay />
        <ModalContent width="950px" height="600px" maxWidth="750px">
          <ModalHeader>Event Details</ModalHeader>
          <Divider /> {/* Divider under Event Details */}
          <ModalCloseButton />
          <ModalBody overflowY="auto" height="450px">
            {formData && (
              <>
                <Text fontWeight="bold" fontSize="lg" mt={4}>
                  {capitalizeWords(formData.title)}{" "}
                  {/* Capitalizing the event title */}
                </Text>
                <Text mt={1}>{capitalizeWords(formData.message)}</Text>{" "}
                {/* Capitalizing the message */}
                <Box mt={4}>
                  <Flex justify="space-between" alignItems="flex-start" mb={2}>
                    {formData.start_date && (
                      <Box>
                        {/* Start Date on the left */}
                        <Text fontSize="sm" fontWeight="bold" color="black">
                          Start Date
                        </Text>
                        <Text fontSize="sm" color="gray.500">
                          {formatDate(formData.start_date)}
                        </Text>
                        {formData.start_time && (
                          <>
                            <Text
                              fontSize="sm"
                              fontWeight="bold"
                              color="black"
                              mt={2}
                            >
                              Start Time
                            </Text>
                            <Text fontSize="sm" color="gray.500">
                              {formData.start_time}
                            </Text>
                          </>
                        )}
                      </Box>
                    )}

                    {formData.end_date && (
                      <Box textAlign="right">
                        {/* End Date on the right */}
                        <Text fontSize="sm" fontWeight="bold" color="black">
                          End Date
                        </Text>
                        <Text fontSize="sm" color="gray.500">
                          {formatDate(formData.end_date)}
                        </Text>
                        {formData.end_time && (
                          <>
                            <Text
                              fontSize="sm"
                              fontWeight="bold"
                              color="black"
                              mt={2}
                            >
                              End Time
                            </Text>
                            <Text fontSize="sm" color="gray.500">
                              {formData.end_time}
                            </Text>
                          </>
                        )}
                      </Box>
                    )}
                  </Flex>

                  {/* Display the file download link */}
                  {formData.attachment && (
                    <Box mt={4}>
                      <Text fontSize="sm" fontWeight="bold" color="black">
                        Attachment
                      </Text>
                      <Button
                        as="a"
                        href={formData.attachment}
                        download
                        colorScheme="teal"
                        mt={2}
                      >
                        Download Attachment
                      </Button>
                    </Box>
                  )}
                </Box>
                {/* Other Event Details */}
                <Divider my={1} />
                {formData.user_types && formData.user_types.length > 0 && (
                  <>
                    <Text fontSize="sm" color="black" fontWeight="bold" mb={2}>
                      Event For
                    </Text>
                    <Flex direction="row" wrap="wrap">
                      {formData.user_types.map((id, index) => (
                        <Box
                          key={index}
                          p={2}
                          bg="teal.100"
                          borderRadius="md"
                          mr={2} // Margin right to separate boxes
                          mb={2} // Margin bottom for spacing when wrapped
                        >
                          <Text fontSize="sm" color="teal.600">
                            {userTypeMapping[id] || "Unknown"}
                          </Text>
                        </Box>
                      ))}
                    </Flex>
                  </>
                )}
                <Divider my={0} />
              </>
            )}
          </ModalBody>
          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};
export default Event;
